import React, { Fragment } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Redirect } from 'react-router-dom';
import TimeAgo from 'timeago-react';
import Observer from 'react-intersection-observer';

import { Row, Col, Badge, Card, CardBody, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import HeaderLogo from '../AppLogo';
import { setUserDetail } from '../../actions/UserAction';

import UserBox from '../../components/UserBox/UserBox';
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';

import UserService from '../../services/UserService';

import './Header.css';

class Header extends React.Component {
  state = {
    isModalVisible: false,
    isNotificationVisible: false,
    notificationData: [],
    unreadNotificationCount: {},
    totalNotificationCount: 0,
    redirectToDashboard: false,
    imageUrl: '',
    isLoading: false
  }

  componentDidMount() {
    this.getUnreadNotificationCount();
  }

  getNotification = async (obj) => {
    let { totalNotificationCount, isLoading } = this.state;
    try {
      let { notificationData } = this.state;
      const { data } = await UserService.getNotification(obj);
      if (data) {
        notificationData = data.data;
        if (obj.from === 'componentDidMount') {
          totalNotificationCount = notificationData.total_count;
          this.setState({ totalNotificationCount });
        }
        this.setState({ notificationData });
      }
      isLoading = false;
      this.setState({ isLoading });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
      console.log(error);
    }
  }

  fetchMoreData = () => {
    const { totalNotificationCount, notificationData } = this.state;
    if (((notificationData || {}).notifications || []).length >= totalNotificationCount) {
      return;
    }

    setTimeout(() => {
      this.getNotification({ page: 1, pagesize: ((notificationData || {}).notifications || []).length + 10 });
    }, 1000);
  }

  getUnreadNotificationCount = async (obj) => {
    try {
      let { unreadNotificationCount } = this.state;
      const { data } = await UserService.getUnreadNotificationCount(obj);
      if (data) {
        unreadNotificationCount = data.data;

        this.setState({ unreadNotificationCount });
      }
    } catch (error) {
      console.log(error);
    }
  }

  openCloseNotificationModal = () => {
    let { isNotificationVisible, unreadNotificationCount, isLoading } = this.state;
    unreadNotificationCount = 0;
    isNotificationVisible = !isNotificationVisible;
    if (isNotificationVisible) {
      isLoading = true;
      this.setState({ isLoading });
      this.getNotification({ page: 1, pagesize: 10, from: 'componentDidMount' });
    }
    this.setState({ isNotificationVisible, unreadNotificationCount });
  }

  goToAction = () => {
    this.setState({ redirectToDashboard: true, isNotificationVisible: false });
  }

  viewCloseImage = (url) => {
    let { imageUrl } = this.state;
    imageUrl = url;
    this.setState({ imageUrl });
  }



  openProfileModal = () => {
    this.setState({ isModalVisible: !this.state.isModalVisible });
  }

  redirectToProfile = () => {
    this.setState({ redirectToProfile: true });
  }

  render() {
    const {
      headerBackgroundColor,
      enableMobileMenuSmall,
      enableHeaderShadow
    } = this.props;

    const { isLoading, notificationData, unreadNotificationCount,
      // totalNotificationCount, isNotificationVisible,
      imageUrl } = this.state;

    return (
      <Fragment>
        {this.state.redirectToDashboard && <Redirect to={{ pathname: '/' }} />}
        {this.state.redirectToProfile && <Redirect to="/profile" />}
        <div id="header">
          <ReactCSSTransitionGroup
            component="div"
            className={cx('app-header', headerBackgroundColor, { 'header-shadow': enableHeaderShadow })}
            transitionName="HeaderAnimation"
            transitionAppear
            transitionAppearTimeout={1500}
            transitionEnter={false}
            transitionLeave={false}>

            <HeaderLogo />
            {/* <div>JkTyre</div> */}
            <div className={cx(
              'app-header__content',
              { 'header-mobile-open': enableMobileMenuSmall },
            )}>
              <div className="app-header-left">
                {/* <SearchBox />
              <MegaMenu /> */}
              </div>
              <div className="app-header-right">
                {/* <HeaderDots /> */}
                {/* <div className="header-btn-lg">
                  <img className="header-menus" src="images/warranty.svg" alt='warranty' />
                </div> */}
                {/* <div >
                  <img className="header-menus" src="images/notif.svg" alt="" />
                </div> */}
                <div>
                  <UncontrolledButtonDropdown id="notification-box">
                    <DropdownToggle>
                      <img className="header-menus"
                        onClick={this.openCloseNotificationModal}
                        src="images/notif.svg"
                        alt=""
                        style={{ cursor: 'pointer' }} />
                      {unreadNotificationCount.count > 0 && <Badge color="danger" style={{ backgroundColor: '#fdbb1f', top: '6px', marginLeft: '-12px', position: 'absolute' }}>{unreadNotificationCount.count}</Badge>}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>
                        {isLoading && <CustomSpinner />}

                        <div style={{ width: '100%' }}
                        // className="arrow_box"
                        >
                          <Card style={{
                            // marginLeft: '-280%', 
                            height: '500px', overflow: 'auto',
                          }}>
                            <CardBody>
                              <Row>
                                <Col>
                                  {
                                    ((notificationData || {}).notifications || []).map((notification, index) => {
                                      return (
                                        <div key={notification.uuid} style={{ cursor: 'pointer' }}>
                                          <Row onClick={() => this.goToAction(notification.action)}>

                                            <Col>
                                              <div>
                                                <span className="title">{notification.title}{' '}</span>
                                                <span className="notification-date-time custom-pull-right">
                                                  <TimeAgo
                                                    datetime={notification.created_at}
                                                    locale='zh' />
                                                </span>
                                              </div>

                                              <div className="notification-desc" style={{ marginTop: '5px' }}>
                                                {notification.message}
                                              </div>
                                            </Col>
                                          </Row>
                                          {notification.image_url && <Row style={{ marginTop: '8px' }}>
                                            <Col>
                                              <span className="custom-anchor-tag pull-right" onClick={() => this.viewCloseImage(notification.image_url)}>View Image</span>
                                            </Col>
                                          </Row>}
                                          {
                                            index + 1 === ((notificationData || {}).notifications || []).length &&
                                            <Observer onChange={this.fetchMoreData}>
                                              <div>&nbsp;</div>
                                            </Observer>
                                          }
                                          <hr />
                                        </div>
                                      );
                                    })}

                                  {
                                    ((notificationData || {}).notifications || []).length === 0 &&
                                    <>
                                      <h6>No notification found</h6>
                                      <hr />

                                    </>
                                  }
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </div>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledButtonDropdown>

                  {/* <img className="header-menus" onClick={this.openCloseNotificationModal} src="images/notif.svg" alt="" style={{ cursor: 'pointer' }} alt='notif' /> */}

                </div>
                {imageUrl && <div style={{ zIndex: "2000", height: '630px', width: '100%', top: '0', left: '0', position: 'absolute', background: 'url(./images/transparent_bg.png)' }}>
                  <Row>
                    <Col>
                      <Row>
                        <Col>
                          <div onClick={() => this.viewCloseImage('')}>
                            &nbsp;&nbsp;&nbsp;
                            <FontAwesomeIcon color="#ed3f32" className="pull-right" icon={faTimes} style={{ fontSize: '35px', cursor: 'pointer', marginRight: '22px', marginTop: '34px' }} />
                            {/* <span className="pull-right">Close</span> */}
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <div style={{ textAlign: 'center' }}>
                        <img src={imageUrl} alt={imageUrl} width="650" height="620" style={{ objectFit: 'contain' }} />
                      </div>
                    </Col>
                  </Row>
                </div>}

                <div className="header-btn-lg">
                  <UserBox />
                </div>

                {/* <UserBox /> */}
                {/* <div className="header-btn-lg">Standard Tyres & Batteries</div> */}
              </div>
            </div>
          </ReactCSSTransitionGroup >
        </div>
      </Fragment >
    );
  }
}


const mapDispatchToProps = dispatch => ({
  setUserDetail: user => dispatch(setUserDetail(user)),
});


const mapStateToProps = state => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
  userDetail: state.User.userDetail,
});


export default connect(mapStateToProps, mapDispatchToProps)(Header);